import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/edu-wave.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              ytURL="jmVAoCwxQFg?si=Y79uowVvgxScs49t"
              title="EduWave"
              description="EduWave empowers teachers with interactive course design tools and providing students with customizable study environments, eduWave enhances focus and engagement in learning. Through features like distraction-blocking applications and gamified learning, eduWave aims to cultivate  collaboration and engagement in learning."
              ghLink="https://github.com/suraj719/eduWave"
              demoLink="https://edu-wave.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              ytURL="cZHNvOTAJQ4?si=Bi4coOkls474Huff"
              title="Trippzy"
              description="Trippzy is the ultimate travel companion, offering innovative features to enhance every aspect of your journey. From a reliable parking management system to personalized trip itineraries generated by AI, organizing and tracking adventures has never been easier. Stay ahead with dynamic weather updates, immerse in local culture with our activity guide, and explore destinations with virtual tours."
              ghLink="https://github.com/suraj719/trippzy"
              demoLink="https://trippzy.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              ytURL="AJGrwNIUF1k?si=CdEad8Sa6ThcG1lG"
              title="Syntexity"
              description="Your ultimate destination for seamless collaborative coding. With robust compilation, advanced editor locking, and real-time chat, coding is efficient and conflict-free. Gain deep insights, manage projects effectively, and enjoy personalized coding experiences. Experience the power of collaboration with Syntexity."
              ghLink="https://github.com/suraj719/syntexity"
              demoLink="https://syntexity.vercel.app/"
            />
          </Col>
          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="BitLogix"
              description="Experience the future of logistics with BitLogix, the ultimate solution for modern supply chain management. From effortless registration to transparent tracking powered by blockchain, automated payments, and robust security, BitLogix streamlines operations. Empower your enterprise with user-friendly interfaces and revolutionary capabilities."
              ghLink="https://github.com/suraj719/BitLogix"
              demoLink="https://bitlogix.vercel.app/"
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
